


















































































import {VUSearchService} from '../../services/vu/search-service';
import {VUFilterService} from '../../services/vu/filter-service';
import BaseSearchLayout from '../../layout/BaseSearchLayout.vue';
import ActiveFilters from '../shared/ActiveFilters.vue';
import FilterCard from '../shared/FilterCard.vue';
import Filters from '../shared/Filters.vue';
import Popup from '../shared/Popup.vue';
import PopupToggle from '../shared/PopupToggle.vue';
import ScopeLinks from '../shared/ScopeLinks.vue';
import Scopes from '../shared/Scopes.vue';
import SearchBar from '../shared/SearchBar.vue';
import SearchResults from '../shared/SearchResults.vue';
import {defineComponent, onMounted} from "@vue/composition-api";
import {useActions, useGetters, useMutations, useState, useStore} from "vuex-composition-helpers";

export default defineComponent({
  name: 'VUSearch',
  components: {
    BaseSearchLayout,
    ActiveFilters,
    FilterCard,
    Filters,
    Popup,
    PopupToggle,
    ScopeLinks,
    Scopes,
    SearchBar,
    SearchResults
  },
  methods: {
    showCount(): boolean {
      let filteredScopeLinks = this.$store.getters['scope/filteredScopeLinks'];
      return filteredScopeLinks && filteredScopeLinks.length > 0;
    }
  },
  setup: () => {
    let mobileFiltersOpened: Boolean = false;
    const store = useStore()
    const {labels} = useGetters(['labels'])
    const {setSearchService} = useMutations(['setSearchService'])
    const {loadData} = useActions(['loadData'])
    const {searchResultsCount, config} = useState(['searchResultsCount', 'config']);

    const {removeActiveScope} = useActions('scope', ['removeActiveScope'])
    const {resetActiveScopes} = useMutations('scope', ['resetActiveScopes'])
    const {scopeList, activeScopeItems} = useState('scope', ['scopeList', 'activeScopeItems'])
    const {activeScopes, filteredScopeLinks} = useGetters('scope', ['activeScopes', 'filteredScopeLinks'])

    const {removeFilter} = useActions('filter', ['removeFilter'])
    const {activeFilterItems, userFilters, mobileFilters} = useState('filter', ['activeFilterItems', 'userFilters', 'mobileFilters'])
    const {activeFilters, filterGroupDisplayNames} = useGetters('filter', ['activeFilters', 'filterGroupDisplayNames'])
    const {
      resetActiveFilters,
      setFilterService,
      toggleMobileFilters
    } = useMutations('filter', ['resetActiveFilters', 'setFilterService', 'toggleMobileFilters'])

    function toggleMobileFiltersCssClass(): void {
      toggleMobileFilters();

      if (mobileFiltersOpened) {
        document.body.classList.add('vuw-overflow-y-hide');
      } else {
        document.body.classList.remove('vuw-overflow-y-hide');
      }
    }

    onMounted(() => {
      try {
        setSearchService(new VUSearchService(config.value))
        setFilterService(new VUFilterService(userFilters.value, labels.value))
      } catch (error) {
        console.error(error)
      } finally {
        loadData([false])
      }
    })

    return {
      config,
      store,
      labels,
      searchResultsCount,
      removeFilter,
      activeFilterItems,
      removeActiveScope,
      resetActiveScopes,
      scopeList,
      activeScopeItems,
      activeFilters,
      filterGroupDisplayNames,
      resetActiveFilters,
      activeScopes,
      filteredScopeLinks,
      mobileFilters,
      toggleMobileFiltersCssClass
    }
  }
})
